import styled from 'styled-components'

export const ModalFooterWrapper = styled.div`
  padding: 10px;
  border-top: 1px solid ${({ theme }) => theme.colors.backgroundLite};

  display: flex;
  align-items: center;
  gap: 10px;

  width: 100%;

  & * {
    text-align: center;
  }
`
